import * as React from 'react';
import {observer} from 'mobx-react';
import {classes, style} from 'typestyle';
import {mediaMobileOnly, mediaTablet} from '../theme/media';
import {centerCenter, horizontal, horizontallySpaced, inlineRoot} from 'csstips';
import {colorBrand, colorSlate, colorSubtle} from '../theme/color';
import {px} from 'csx';

export interface PageCheckoutHeaderMenuModel {
  step: number;
}

export interface PageCheckoutHeaderMenuProps {
  model: PageCheckoutHeaderMenuModel;
  onSelectStep(step: number): void;
  i18n?: {
    step1: string;
    step2: string;
    step3: string;
    step4: string;
  }
}

const DEFAULT_I18N = {
  step1: 'Review order',
  step2: 'Payment details',
  step3: 'Confirm order',
  step4: 'Download tracks'
};

@observer
export class PageCheckoutHeaderMenu extends React.Component<PageCheckoutHeaderMenuProps, any> {
  render() {
    const { i18n = DEFAULT_I18N, model } = this.props;
    const { step } = model;

    return (
      <div className={PageCheckoutHeaderMenu.styles.container}>
        <ul className={PageCheckoutHeaderMenu.styles.tabs}>
          <li className={this.getTabClass(0, step)} onClick={this.handleClick.bind(null, 0)}>
            {i18n.step1}
          </li>
          <li className={this.getTabClass(2, step)} onClick={this.handleClick.bind(null, 2)}>
            {i18n.step3}
          </li>
          <li className={this.getTabClass(3, step)} onClick={this.handleClick.bind(null, 3)}>
            {i18n.step4}
          </li>
        </ul>
      </div>
    )
  }

  getTabClass = (step: number, current: number) => classes(
    PageCheckoutHeaderMenu.styles.tab,
    // step < current && tabVisited,
    step === current ? PageCheckoutHeaderMenu.styles.tabActive : PageCheckoutHeaderMenu.styles.tabHiddenMobile
);

  handleClick = (step: number, event: React.MouseEvent<any>) => {
    event.preventDefault();
    this.props.onSelectStep(step);
  };

  handleChange = (event: React.FormEvent<any>) => {
    const { value } = event.target as HTMLSelectElement;
    this.props.onSelectStep(parseInt(value));
  };

  static styles = {
    container: style(
      mediaMobileOnly({
        // $nest: { '&> ul': { display: 'none' } }
      }),
      mediaTablet({
        $nest: { '&> select': { display: 'none' } }
      })
    ),
    tabs: style({
      ...horizontal,
      ...horizontallySpaced(30),
      margin: 0,
      padding: 0,
      listStyle: 'none inside none',
    }),
    tab: style({
      ...inlineRoot,
      ...centerCenter,
      height: px(70),
      userSelect: 'none',
      cursor: 'pointer',
      color: colorSubtle.toString(),
      borderColor: 'transparent',
      borderBottom: `4px solid`,
      borderTop: `4px solid transparent`,
      fontWeight: 'bold',
      ...mediaMobileOnly({
        height: px(50)
      })
    }),
    tabActive: style({
      borderBottomColor: colorBrand.toString(),
      color: colorSlate.toString(),
    }),
    tabHiddenMobile: style(mediaMobileOnly({
      display: 'none'
    }))
  }
}